<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Sea Import</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button
                  v-if="ffExoprtDetail.ffImportId!=''"
                  @click="addStatus"
                  style="position: fixed;z-index:999;top:83%;"
                  class="md-fab"
                >
                  <md-icon>message</md-icon>
                </md-button>
              </md-layout>
            </md-layout> -->
            <md-layout md-gutter>
              <md-layout md-flex="15">
                <label for="containerInfo">FF Activity</label>
                <model-list-select
                  isDisabled
                  :list="containerInfoList"
                  v-model="ffExoprtDetail.containerInfo"
                  option-value="containerInfoVal"
                  option-text="containerInfoText"
                  placeholder="Select Container Load"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                <model-list-select
                  :list="deliveryTermsList"
                  v-model="ffExoprtDetail.deliveryTerms"
                  option-value="deliveryTermsVal"
                  option-text="deliveryTermsText"
                  placeholder="Select Delivery Terms"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label for="stuffingType">De-Stuffing Type</label>
                <model-list-select
                  :list="stuffingTypeName"
                  v-model="ffExoprtDetail.stuffingType"
                  option-value="stuffingTypeVal"
                  option-text="stuffingTypeText"
                  placeholder="Select Type"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label for="agentName">Agent Name</label>
                <model-list-select
                  :list="getagentName"
                  v-model="ffExoprtDetail.agentName"
                  option-value="agntColoaderId"
                  option-text="agentName"
                  placeholder="Select Agent Name"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <label for="clientId">Importer Name</label>

                <model-list-select
                  isDisabled
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.importerClientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Importer Name"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.importerClientId">{{
                  ffExporterrorList.importerClientId
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="55">
                <label for="exporterName">Exporter Name</label>
                <model-list-select
                  isDisabled
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.exporterClientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Exporter Name"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.exporterClientId">{{
                  ffExporterrorList.exporterClientId
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <label for="bookingParty">Booking Party</label>
                <model-list-select
                  :list="bookingPartyList"
                  v-model="ffExoprtDetail.bookingParty"
                  option-value="billingPartyVal"
                  option-text="billingPartyTxt"
                  placeholder="Select Booking Party"
                ></model-list-select>
              </md-layout>
              <md-layout
                md-flex="5"
                v-if="ffExoprtDetail.bookingParty == 'Other'"
              ></md-layout>

              <md-layout
                md-flex="55"
                v-if="ffExoprtDetail.bookingParty == 'Other'"
              >
                <label for="sourceOriginclientId"
                  >Client Name (Booking Party)</label
                >
                <model-list-select
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.sourceOriginclientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Client Name"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout
                md-flex="40"
                v-if="ffExoprtDetail.containerInfo == 'lcl'"
              >
                <label for="agentName">CoLoader Name</label>
                <model-list-select
                  :list="getColoaderNameList"
                  v-model="ffExoprtDetail.coLoaderName"
                  option-value="agntColoaderId"
                  option-text="coLoaderName"
                  placeholder="Select Coloader "
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.coLoaderName">{{
                  ffExporterrorListLCL.coLoaderName
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Place Of Receipt</label>
                  <b-form-input :formatter="capitalizeAll"
                    disabled
                    id="placeOfReceipt"
                    name="placeOfReceipt"
                    v-model="ffExoprtDetail.placeOfReceipt"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="55">
                <md-layout md-flex="100">
                  <label>Load Port</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="loadPort"
                    name="loadPort"
                    disabled
                    v-model="ffExoprtDetail.loadPort"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Port Of Discharge</label>
                  <b-form-input :formatter="capitalizeAll"
                    disabled
                    id="portOfDischarge"
                    name="portOfDischarge"
                    v-model="ffExoprtDetail.portOfDischarge"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="55">
                <md-layout md-flex="100">
                  <label>Final Place Of Delivery</label>
                  <b-form-input :formatter="capitalizeAll"
                    disabled
                    id="finalPlaceDelivery"
                    name="finalPlaceDelivery"
                    v-model="ffExoprtDetail.finalPlaceDelivery"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="15">
                <label>SOB Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="sailDate"
                  name="sailDate"
                  v-model="ffExoprtDetail.sailDate"
                ></date-picker>
                <span class="error" v-if="!ffExoprtDetail.sailDate">{{
                  ffExporterrorList.sailDate
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Pre-Alert Received Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="alertReceivedDate"
                  name="alertReceivedDate"
                  v-model="ffExoprtDetail.alertReceivedDate"
                ></date-picker>
                <span class="error" v-if="!ffExoprtDetail.alertReceivedDate">{{
                  ffExporterrorList.alertReceivedDate
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>IGM Manifestation Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  :not-after="new Date()"
                  id="igmManifestationDate"
                  name="igmManifestationDate"
                  v-model="ffExoprtDetail.igmManifestationDate"
                ></date-picker>
                <!-- <span class="error" v-if="!ffExoprtDetail.sailDate">{{ffExporterrorList.sailDate}}</span> -->
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Vessel ETA Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="vesselEtaDate"
                  name="vesselEtaDate"
                  v-model="ffExoprtDetail.vesselEtaDate"
                ></date-picker>
                <!-- <span class="error" v-if="!ffExoprtDetail.sailDate">{{ffExporterrorList.sailDate}}</span> -->
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Free Days at India Port</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="freeDaysIndiaPort"
                    name="freeDaysIndiaPort"
                    type="number"
                    min="0"
                    v-model="ffExoprtDetail.freeDaysIndiaPort"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="55">
                <label for="deliveryMode">Destination Handling Fees By</label>
                <model-list-select
                  :list="destiHandleList"
                  v-model="ffExoprtDetail.destinationHandling"
                  option-value="DHVal"
                  option-text="DHText"
                  placeholder="Select Destination Handling Fees By"
                ></model-list-select>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>B/L Number</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="firstBLNumber"
                    name="firstBLNumber"
                    v-model="ffExoprtDetail.firstBLNumber"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!ffExoprtDetail.firstBLNumber">{{
                  ffExporterrorList.firstBLNumber
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="firstBlType">B/L Type</label>
                <model-list-select
                  :list="
                    ffExoprtDetail.containerInfo == 'fcl'
                      ? blTypeList
                      : blTypeListLcl
                  "
                  v-model="ffExoprtDetail.firstBlType"
                  option-value="blTypeVal"
                  option-text="blTypeTxt"
                  placeholder="Select B/L Type"
                  isDisabled
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>B/L Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="firstBLDate"
                  name="firstBLDate"
                  v-model="ffExoprtDetail.firstBLDate"
                ></date-picker>
                <span class="error" v-if="!ffExoprtDetail.firstBLDate">{{
                  ffExporterrorList.firstBLDate
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <label for="deliveryTerms">Ocean Freight</label>
                <model-list-select
                  :list="oceanFreightTermsList"
                  v-model="ffExoprtDetail.firstOcFreghtTerms"
                  option-value="oceanFreightTermsVal"
                  option-text="oceanFreightTermsText"
                  placeholder="Select Ocean Freight"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <md-radio
                  style="margin-top: 25px"
                  id="permitted1"
                  name="permitted1"
                  md-value="Original"
                  v-model="ffExoprtDetail.firstBLRadio"
                  class="md-primary"
                  >Original</md-radio
                >
              </md-layout>

              <md-layout md-flex="15">
                <md-radio
                  style="margin-top: 25px"
                  id="permitted2"
                  name="permitted2"
                  v-model="ffExoprtDetail.firstBLRadio"
                  md-value="seaWayBl"
                  class="md-primary"
                  >Sea Way B/L</md-radio
                >
                <span class="error" v-if="!ffExoprtDetail.firstBLRadio">{{
                  ffExporterrorList.firstBLRadio
                }}</span>
              </md-layout>
              <b-button
                size="sm"
                style="margin-top: 38px"
                @click="showDocModal"
                variant="dark"
                >Upload B/L</b-button
              >

              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-input-container>
                  <label>Upload B/L</label>
                  <md-file
                    name="firstBLupload"
                    id="firstBLupload"
                    v-model="ffExoprtDetail.firstBLupload"
                    @selected="onFileChange('FIRST')"
                    multiple
                  ></md-file>
                </md-input-container>
              </md-layout> -->
            </md-layout>
            <md-layout md-gutter v-if="firstBlUploadView.length > 0">
              <md-layout md-flex="80"></md-layout>
              <md-layout
                md-flex="15"
                v-for="(item, index) in firstBlUploadView"
                :key="index"
              >
                <a
                  :href="`${docURL}/FF_Sea_Import_Uploads/` + item"
                  target="_blank"
                  download
                  >View Document - {{ index + 1 }}</a
                >
              </md-layout>
            </md-layout>

            <md-layout
              gutter
              class="gutr"
              v-if="ffExoprtDetail.firstBLRadio == 'Original'"
            >
              <md-layout md-flex="15">
                <label>Surrender Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="secondBLDate"
                  name="secondBLDate"
                  v-model="ffExoprtDetail.surrenderDate"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Original BL Received Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="originalBlRecDate"
                  name="originalBlRecDate"
                  v-model="ffExoprtDetail.originalBlRecDate"
                ></date-picker>
              </md-layout>
            </md-layout>
            <md-layout gutter class="gutr">
              <md-layout
                md-flex="100"
                v-for="(singleInputM, index) in ffExoprtDetail.notifyList"
                :key="index"
              >
                <md-layout md-flex="100">
                  <md-layout md-flex="60" class="gutr">
                    <label
                      >{{ notifyArray[index] }} Notify Name & Address</label
                    >
                  </md-layout>
                  <md-layout md-flex="15" class="gutr" v-if="index > 1">
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="removeNotifyMaster(index)"
                      style="min-height: 20px; height: 20px"
                    >
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <b-form-textarea :formatter="capitalizeAll"
                      id="inputValue"
                      name="inputValue"
                      v-model="singleInputM.inputValue"
                    ></b-form-textarea>
                    <!-- <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor> -->
                  </md-layout>
                </md-layout>
              </md-layout>
              <!-- <md-button style="margin-top:18px; height: 10px;  width: 39px;" class="md-fab md-fab">
            <md-icon>add</md-icon>
              </md-button>-->
            </md-layout>

            <md-layout gutter class="gutr">
              <b-button
                size="sm"
                variant="outline-dark"
                @click="addNotifyMaster"
                >Add More Notify</b-button
              >

              <md-layout md-flex="30"></md-layout>
            </md-layout>
            <!-- <md-layout md-gutter v-if="getHouseBLData.length>0 &&  HouseBLModel.houseBLId=='' ">
          <md-layout md-flex="75"></md-layout>

          <md-layout md-flex="25">
            <h4
              @click="showMoreShipper"
              class="showMoreData"
            >Click here to {{openShipper==true?"Hide":"Add More"}} House BL</h4>
          </md-layout>
            </md-layout>-->
            <div>
              <div
                class="mt-2"
                v-if="
                  getHouseBLData.length == 0 ||
                  openShipper == true ||
                  HouseBLModel.houseBLId != ''
                "
              >
                <b-card>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="40">
                      <md-layout md-flex="100">
                        <label>B/L Number</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="secondBLNumber"
                          name="secondBLNumber"
                          v-model="HouseBLModel.secondBLNumber"
                        ></b-form-input>
                      </md-layout>
                      <span class="error" v-if="!HouseBLModel.secondBLNumber">{{
                        HouseBLModelError.secondBLNumber
                      }}</span>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="35">
                      <label for="secondBlType">B/L Type</label>
                      <!-- :isDisabled="ffExoprtDetail.firstBlType=='MasterBL'" -->
                      <model-list-select
                        :list="
                          ffExoprtDetail.containerInfo == 'fcl'
                            ? blTypeList
                            : blTypeListLcl
                        "
                        v-model="HouseBLModel.secondBlType"
                        option-value="blTypeVal"
                        option-text="blTypeTxt"
                        placeholder="Select B/L Type"
                      ></model-list-select>
                      <span class="error" v-if="!HouseBLModel.secondBlType">{{
                        HouseBLModelError.secondBlType
                      }}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <label>B/L Date</label>
                      <date-picker
                      :format="selectDateFormat"
                        lang="en"
                        id="secondBLDate"
                        name="secondBLDate"
                        v-model="HouseBLModel.secondBLDate"
                      ></date-picker>
                      <span class="error" v-if="!HouseBLModel.secondBLDate">{{
                        HouseBLModelError.secondBLDate
                      }}</span>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="gutr">
                    <md-layout
                      md-flex="50"
                      v-for="(singleInput, index) in HouseBLModel.notifyList"
                      :key="index"
                    >
                      <md-layout md-flex="100">
                        <md-layout md-flex="60" class="gutr">
                          <label
                            >{{ notifyArray[index] }} Notify Name &
                            Address</label
                          >
                        </md-layout>
                        <md-layout md-flex="15" class="gutr" v-if="index > 1">
                          <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="removeNotify(index)"
                            style="min-height: 20px; height: 20px"
                          >
                            <md-icon>close</md-icon>
                          </md-button>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="100">
                        <md-layout md-flex="85">
                          <b-form-textarea :formatter="capitalizeAll"
                            id="inputValue"
                            name="inputValue"
                            v-model="singleInput.inputValue"
                          ></b-form-textarea>
                          <!-- <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor> -->
                        </md-layout>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="gutr">
                    <md-layout md-flex="30">
                      <b-button
                        size="sm"
                        variant="outline-dark"
                        @click="addNotify"
                        >Add More Notify</b-button
                      >

                      <md-spinner
                        md-indeterminate
                        id="loader1"
                        style="display: none"
                      ></md-spinner>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="40">
                      <label for="secondOcFreghtTerms">Ocean Freight</label>
                      <model-list-select
                        :list="oceanFreightTermsList"
                        v-model="HouseBLModel.secondOcFreghtTerms"
                        option-value="oceanFreightTermsVal"
                        option-text="oceanFreightTermsText"
                        placeholder="Select Ocean Freight"
                      ></model-list-select>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="10">
                      <md-radio
                        style="margin-top: 25px"
                        id="permitted1"
                        name="permitted1"
                        md-value="Original"
                        v-model="HouseBLModel.secondBLRadio"
                        class="md-primary"
                        >Original</md-radio
                      >
                    </md-layout>

                    <md-layout md-flex="15">
                      <md-radio
                        style="margin-top: 25px"
                        id="permitted2"
                        name="permitted2"
                        v-model="HouseBLModel.secondBLRadio"
                        md-value="seaWayBl"
                        class="md-primary"
                        >Sea Way B/L</md-radio
                      >
                      <span class="error" v-if="!HouseBLModel.secondBLRadio">{{
                        HouseBLModelError.secondBLRadio
                      }}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <md-input-container>
                          <label>Upload B/L</label>
                          <md-file
                            name="secondBLupload"
                            id="secondBLupload"
                            v-model="HouseBLModel.secondBLupload"
                            @selected="onFileChange('SECOND')"
                            multiple
                          ></md-file>
                        </md-input-container>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter v-if="secondBlUploadView.length > 0">
                    <md-layout md-flex="80"></md-layout>
                    <md-layout
                      md-flex="15"
                      v-for="(item, index) in secondBlUploadView"
                      :key="index"
                    >
                      <a
                        :href="
                          `${docURL}/FF_Sea_Import_Uploads/` + item
                        "
                        target="_blank"
                        download
                        >View Document - {{ index + 1 }}</a
                      >
                    </md-layout>
                  </md-layout>
                  <md-layout
                    gutter
                    class="gutr"
                    v-if="HouseBLModel.secondBLRadio == 'Original'"
                  >
                    <md-layout md-flex="15">
                      <label>Surrender Date</label>
                      <date-picker
                      :format="selectDateFormat"
                        lang="en"
                        id="secondBLDate"
                        name="secondBLDate"
                        v-model="HouseBLModel.surrenderDate"
                      ></date-picker>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <label>Original BL Received Date</label>
                      <date-picker
                      :format="selectDateFormat"
                        lang="en"
                        id="originalBlRecDate"
                        name="originalBlRecDate"
                        v-model="HouseBLModel.originalBlRecDate"
                      ></date-picker>
                    </md-layout>
                  </md-layout>

                  <md-layout gutter class="gutr">
                    <md-layout md-flex="90"></md-layout>

                    <md-layout md-flex="10">
                      <b-button
                        class="smbutnWidth mt-2"
                        variant="info"
                        size="sm"
                        id="addButtonLoader"
                        @click="addFFSeaImport('3')"
                        >{{
                          HouseBLModel.houseBLId == "" ? "Add" : "Update"
                        }}
                        BL</b-button
                      >
                      <md-spinner
                        md-indeterminate
                        id="loader3"
                        style="display: none"
                      ></md-spinner>
                    </md-layout>
                  </md-layout>
                </b-card>
              </div>

              <div class="mt-3" v-if="getHouseBLData.length > 0">
                <div>
                  <h5>
                    <b-badge>House-BL Details</b-badge>
                  </h5>
                  <md-button
                    v-if="
                      getHouseBLData.length > 0 && HouseBLModel.houseBLId == ''
                    "
                    @click="showMoreShipper"
                    style="height: 10px; width: 39px"
                    class="md-fab md-fab pull-right"
                  >
                    <md-icon v-if="openShipper == false">add</md-icon>
                    <md-icon v-else>cancel</md-icon>
                  </md-button>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                  <table id="FreghtContaner" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>B/L Number</th>
                        <th>Type</th>
                        <th>Ocean Freight Terms</th>
                        <!-- <th v-if="ExecutionDisable==''">Delete</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item1, index) in getHouseBLData" :key="index">
                        <td class="showMoreData" @click="editHouseBL(item1)">
                          {{ item1.secondBLNumber }}
                        </td>
                        <td>{{ item1.secondBLRadio }}</td>
                        <td>{{ item1.secondOcFreghtTerms }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>

              <!-- <hr class="hr-border" v-if="ffExoprtDetail.containerInfo=='lcl'" />
        <md-layout md-gutter class="gutr" v-if="ffExoprtDetail.containerInfo=='lcl'">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Master B/L Number</label>
              <b-form-input :formatter="capitalizeAll"
                id="masterBLNumber"
                name="masterBLNumber"
                v-model="ffExoprtDetail.lclmasterBLNumber"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label>B/L Date</label>
            <date-picker
              lang="en"
              id="masterBLDate"
              name="masterBLDate"
              v-model="ffExoprtDetail.lclmasterBLDate"
            ></date-picker>
          </md-layout>
              </md-layout>-->
            </div>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <label for="ccType">Custom Clearance Type</label>
                <model-list-select
                  :list="cctypeList"
                  v-model="ffExoprtDetail.ccOutSourced"
                  option-value="ccTypeVal"
                  option-text="ccTypeTxt"
                  placeholder="Select CC Type"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="55" v-if="ffExoprtDetail.ccOutSourced == '2'">
                <md-layout md-flex="100">
                  <label>CHA Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="ccCha"
                    name="ccCha"
                    v-model="ffExoprtDetail.ccChaName"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <label for="ccType">Transportation Type</label>
                <model-list-select
                  :list="cctypeList"
                  v-model="ffExoprtDetail.tptOutSource"
                  option-value="ccTypeVal"
                  option-text="ccTypeTxt"
                  placeholder="Select TPT Type"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="55" v-if="ffExoprtDetail.tptOutSource == '2'">
                <md-layout md-flex="100">
                  <label>Transporter Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="tptChaName"
                    name="tptChaName"
                    v-model="ffExoprtDetail.tptChaName"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <label for="shippingId">Shipping Line Name</label>
                <model-list-select
                  :list="shippingList"
                  v-model="ffExoprtDetail.shippingId"
                  option-value="shippingId"
                  option-text="shippingLine"
                  placeholder="Select Shipping Line"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.shippingId">{{
                  ffExporterrorList.shippingId
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <md-layout md-flex="100">
                  <label>Gateway IGM No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="preCarriageBy"
                    name="preCarriageBy"
                    v-model="ffExoprtDetail.gateWayIgmNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Gateway IGM Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="gatewayIgmDate"
                  name="gatewayIgmDate"
                  v-model="ffExoprtDetail.gatewayIgmDate"
                ></date-picker>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Vessel/Voyage</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="vesselVoyage"
                    name="vesselVoyage"
                    v-model="ffExoprtDetail.vesselVoyage"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Vessel Arrival Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="gatewayIgmDate"
                  name="gatewayIgmDate"
                  v-model="ffExoprtDetail.vesselArrivalDate"
                ></date-picker>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <label for="shipmentType">Source Of Booking</label>

            <model-list-select
              :list="shipTypeList"
              v-model="ffExoprtDetail.shipType"
              option-value="shipTypeVal"
              option-text="shipTypeText"
              placeholder="Select Source "
            ></model-list-select>
              </md-layout>-->
            </md-layout>
            <!-- <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30" v-if="ffExoprtDetail.shipType=='Origin'">
            <label for="agentName">Agent Name</label>
            <model-list-select
              :list="agentNameList"
              v-model="ffExoprtDetail.agentName"
              option-value="agntColoaderId"
              option-text="agentName"
              placeholder="Select Agent Name"
            ></model-list-select>
          </md-layout>
        <md-layout md-flex="30" v-if="ffExoprtDetail.shipType=='Destination'">
            <label for="sourceOriginclientId">Client Name</label>
            <model-list-select
              :list="clientList"
              id="clientNamenew"
              v-model="ffExoprtDetail.sourceOriginclientId"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select Client Name"
            ></model-list-select>
          </md-layout>
      <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25" v-if="ffExoprtDetail.shipType=='Destination'">
            <md-layout md-flex="100">
              <label>Buyer Name</label>
              <b-form-input :formatter="capitalizeAll" id="buyer" name="buyer" v-model="ffExoprtDetail.buyer"></b-form-input>
            </md-layout>
          </md-layout>
     
          <md-layout md-flex="25" v-if="ffExoprtDetail.shipType=='Origin'">
            <md-layout md-flex="100">
              <label>Enter Buying House</label>
              <b-form-input :formatter="capitalizeAll"
                id="buyingHouse"
                name="buyingHouse"
                v-model="ffExoprtDetail.buyingHouse"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25" v-if="ffExoprtDetail.shipType=='Origin'">
            <md-layout md-flex="100">
              <label>Other Specify</label>
              <b-form-input :formatter="capitalizeAll"
                id="otherSpecify"
                name="otherSpecify"
                v-model="ffExoprtDetail.otherSpecify"
              ></b-form-input>
            </md-layout>
          </md-layout>
            </md-layout>-->
            <md-layout md-gutter class="gutr" v-if="showLocalIgmDiv == true">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Local IGM No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="preCarriageBy"
                    name="preCarriageBy"
                    v-model="ffExoprtDetail.localIgmNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Local IGM Date</label>
                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="gatewayIgmDate"
                  name="gatewayIgmDate"
                  v-model="ffExoprtDetail.localIgmDate"
                ></date-picker>
              </md-layout>
            </md-layout>
            <div class="mt-3">
              <h5>
                <b-badge>Container Details</b-badge>
              </h5>

              <!--  -->
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="80">
                  <b-form-checkbox
                    @change="addSameDateRadio"
                    id="checkbox-1"
                    v-model="allSame"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0"
                    >Port ETA Date,CFS Arrival Date,Free Days Upto is
                    Same</b-form-checkbox
                  >
                </md-layout>
              </md-layout>
              <!-- <md-layout md-gutter class="gutr" v-if="ccContainers!=''">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="90">
                  <label>Containers No Details</label>
                  <b-form-textarea :formatter="capitalizeAll" id="noOfContainers" name="noOfContainers" v-model="ccContainers"></b-form-textarea>
                </md-layout>
                </md-layout>-->
              <div class="mt-3" v-if="multiContainer.length > 0">
                <table class="table table-bordered table-striped">
                  <tbody>
                    <tr>
                      <th>Sr No.</th>
                      <th>Container No.(AAAA1234567)</th>
                      <th>Container Type/Size</th>
                      <th>
                        {{
                          showLocalIgmDiv == false
                            ? "Port ETA Date"
                            : "Rail Out Date"
                        }}
                      </th>
                      <th>
                        {{
                          showLocalIgmDiv == false
                            ? "CFS Arrival Date"
                            : "ICD Arrival Date"
                        }}
                      </th>

                      <th>Free Days Upto</th>
                    </tr>
                    <tr v-for="(item, index) in multiContainer" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <b-form-input :formatter="capitalizeAll"
                          maxlength="11"
                          @keyup="containerNoRegexfun(index)"
                          v-model="multiContainer[index].ContainerNo"
                        ></b-form-input>
                        <span
                          v-if="multiContainer[index].ContainerNo != ''"
                          class="error"
                          >{{ containerNoRegexError[index] }}</span
                        >
                      </td>

                      <td>
                        <model-list-select
                          isDisabled
                          :list="ContainerTypeList"
                          v-model="multiContainer[index].ContainerType"
                          option-value="containerTypeId"
                          option-text="containerType"
                          placeholder="Select Container Type"
                        ></model-list-select>
                      </td>
                      <td>
                        <date-picker
                        :format="selectDateFormat"
                          @change="addSameDate(index)"
                          lang="en"
                          id="railOutDate"
                          name="railOutDate"
                          v-model="multiContainer[index].railOutDate"
                        ></date-picker>
                      </td>
                      <td>
                        <date-picker
                        :format="selectDateFormat"
                          @change="addSameDate(index)"
                          lang="en"
                          id="arrivalDate"
                          name="arrivalDate"
                          v-model="multiContainer[index].arrivalDate"
                        ></date-picker>
                      </td>
                      <td>
                        <date-picker
                        :format="selectDateFormat"
                          @change="addSameDate(index)"
                          lang="en"
                          id="freeDays"
                          name="freeDays"
                          v-model="multiContainer[index].freeDays"
                        ></date-picker>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- <b-card class="gutr" style="background:whiteSmoke">
                <md-layout gutter class="gutr">
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="15">
                    <label>Container No.(AAAA1234567)</label>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <label for="containerTypeId">Container Type/Size</label>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label v-if="showLocalIgmDiv==false">Port ETA Date</label>
                    <label v-else>Rail Out Date</label>
                  </md-layout>

                  <md-layout md-flex="15">
                    <label v-if="showLocalIgmDiv==false">CFS Arrival Date</label>
                    <label v-else>ICD Arrival Date</label>
                  </md-layout>

                  <md-layout md-flex="15">
                    <label>Free Days Upto</label>
                  </md-layout>
                </md-layout>
                <md-layout gutter v-for="(item,index) in multiContainer" :key="index" class="gutr">
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="15">
                    <b-form-input :formatter="capitalizeAll"
                      maxlength="11"
                      @keyup="containerNoRegexfun(index)"
                      v-model="multiContainer[index].ContainerNo"
                    ></b-form-input>
                    <span
                      v-if="multiContainer[index].ContainerNo!=''"
                      class="error"
                    >{{containerNoRegexError[index]}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <model-list-select
                      isDisabled
                      :list="ContainerTypeList"
                      v-model="multiContainer[index].ContainerType"
                      option-value="containerTypeId"
                      option-text="containerType"
                      placeholder="Select Container Type"
                    ></model-list-select>
                  
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <date-picker
                      @change="addSameDate(index)"
                      lang="en"
                      id="railOutDate"
                      name="railOutDate"
                      v-model="multiContainer[index].railOutDate"
                    ></date-picker>
                  </md-layout>

                  <md-layout md-flex="15">
                    <date-picker
                      @change="addSameDate(index)"
                      lang="en"
                      id="arrivalDate"
                      name="arrivalDate"
                      v-model="multiContainer[index].arrivalDate"
                    ></date-picker>
                  </md-layout>

                  <md-layout md-flex="15">
                    <date-picker
                      @change="addSameDate(index)"
                      lang="en"
                      id="freeDays"
                      name="freeDays"
                      v-model="multiContainer[index].freeDays"
                    ></date-picker>
                  </md-layout>
                  <md-layout md-flex="5">
                  
                  </md-layout>
                </md-layout>
              </b-card> -->
            </div>
            <md-layout gutter class="gutr">
              <md-layout md-flex="75">
                <label>Commodity Name, HSN Code and Type</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="commodity"
                  name="commodity"
                  v-model="ffExoprtDetail.commodity"
                ></b-form-textarea>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label for="deliveryMode">Destination Delivery Mode</label>
                <model-list-select
                  :list="deliveryModeList"
                  v-model="ffExoprtDetail.deliveryMode"
                  option-value="deliveryModeVal"
                  option-text="deliveryModeText"
                  placeholder="Select Delivery Mode"
                ></model-list-select>
              </md-layout>
            </md-layout>

            <md-layout gutter class="gutr">
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Remarks</label>
                  <b-form-textarea :formatter="capitalizeAll"
                    id="remarks"
                    name="remarks"
                    v-model="ffExoprtDetail.remarks"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <div>
              <b-button
                size="sm"
                style="margin-top: 38px"
                @click="showDocModal"
                variant="dark"
                >Upload Documents</b-button
              >
            </div>
            <div class="gutr">
              <b-button
                variant="primary"
                class="mt-2"
                id="addButtonLoader"
                @click="addFFSeaImport('0')"
                >Save & Submit</b-button
              >
            </div>
            <div>
              <b-button
                variant="primary"
                class="mt-1"
                id="addButtonLoader"
                @click="addFFSeaImport('1')"
                >Save and Proceed to Payment Detail</b-button
              >
              <md-spinner
                md-indeterminate
                id="loader"
                style="display: none"
              ></md-spinner>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="onCloseAddSeaImp"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <md-dialog-alert
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="message"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/seaImport/ffseaImportFcl");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ffExoprtDetail: {
      handler: function (newVal, oldVal) {
        if (this.ffExoprtDetail.importerClientId != "") {
          let importerName = this.getCLientData.filter((x) => {
            return x.clientId == this.ffExoprtDetail.importerClientId;
          });

          this.ffExoprtDetail.importerName = importerName[0].clientName;
        }
        // if (this.ffExoprtDetail.exporterClientId != "") {
        //   let exporterName = this.getCLientData.filter(x => {
        //     return x.clientId == this.ffExoprtDetail.exporterClientId;
        //   });

        //   this.ffExoprtDetail.exporterName = exporterName[0].clientName;
        // }
        //   console.log(this.ffExoprtDetail);
        // if (this.ffExoprtDetail.etaFinalDestination != "") {
        //   this.getDayFromDate = new Date(
        //     this.ffExoprtDetail.etaFinalDestination
        //   );

        //   let result = new Date(this.ffExoprtDetail.etaFinalDestination);

        //   let frrD = result + this.ffExoprtDetail.freeDetentionDesti;

        //   // return result;

        //   //         this.ffExoprtDetail.lastFreeDay =
        //   //           this.getDayFromDate +
        //   //           parseInt(this.ffExoprtDetail.freeDetentionDesti);
        //   console.log(
        //     // this.getDayFromDate,
        //     // this.ffExoprtDetail.lastFreeDay,
        //     result,
        //     frrD,
        //     "iuiuou"
        //   );
        // }
        if (this.ffExoprtDetail.containerInfo == "fcl") {
          this.ffExoprtDetail.firstBlType = "MasterBL";
        } else {
          this.ffExoprtDetail.firstBlType = "Co-Loader";
        }

        // if (this.ffExoprtDetail.PORlocationId != "") {
        //   let array = this.IcdPOrtList.filter(x => {
        //     return x.pickupId == newVal.PORlocationId;
        //   })[0];

        //   this.ffExoprtDetail.portType = array.locationType;
        //   if (array.locationType != "Icd") {
        //     this.PortLoadList = this.IcdPOrtList;
        //     this.ffExoprtDetail.LPlocationId = newVal.PORlocationId;
        //   }

        //   this.deliveryTermsList[1].deliveryTermsText =
        //     "FOB_POR_ " + array.mainLocation;
        // }
        // if (this.ffExoprtDetail.LPlocationId != "") {
        //   let array = this.PortLoadList.filter(x => {
        //     return x.pickupId == this.ffExoprtDetail.LPlocationId;
        //   })[0];
        //   this.deliveryTermsList[2].deliveryTermsText =
        //     "FOB_LP_ " + array.mainLocation;
        // }

        // if (this.ffExoprtDetail.finalPlaceLocationId != "") {
        //   let arrayFPODTYPE = this.finalAllPlaceData.filter(x => {
        //     return x.pickupId == this.ffExoprtDetail.finalPlaceLocationId;
        //   });
        //   if (arrayFPODTYPE.length > 0) {
        //     if (
        //       arrayFPODTYPE[0].locationType == "Sea_Port" ||
        //       arrayFPODTYPE[0].locationType == "Air_Port"
        //     ) {
        //       this.$sessionsStorage.set("FPODTYPE", "PORT");
        //     } else {
        //       this.$sessionsStorage.set("FPODTYPE", "ICD");
        //     }
        //   }
        // }
        // if (this.ffExoprtDetail.PORlocationId != "") {
        //   let arrayPORTYPE = this.IcdPOrtListNew.filter(x => {
        //     return x.pickupId == this.ffExoprtDetail.PORlocationId;
        //   });
        //   if (arrayPORTYPE.length > 0) {
        //     if (arrayPORTYPE[0].locationType == "Sea_Port") {
        //       this.$sessionsStorage.set("PORTYPE", "SEA");
        //     } else {
        //       this.$sessionsStorage.set("PORTYPE", "ICD");
        //     }
        //   }
        // }

        if (this.ffExoprtDetail.importerClientId != "") {
          let arrayImp = this.getCLientData.filter((x) => {
            return x.clientId == this.ffExoprtDetail.importerClientId;
          });

          if (arrayImp.length > 0) {
            this.bookingPartyList[0].billingPartyTxt =
              "Importer_" + arrayImp[0].clientName;
            this.showAdditionalMoreTaskArray[0].show =
              "Importer_" + arrayImp[0].clientName;
          }
        }
        // if (this.ffExoprtDetail.exporterClientId != "") {
        //   this.bookingPartyList[1].billingPartyTxt =
        //     "Exporter_" + this.ffExoprtDetail.exporterName;
        //   this.showAdditionalMoreTaskArray[1].show =
        //     "Exporter_" + this.ffExoprtDetail.exporterName;
        // }
        if (this.ffExoprtDetail.agentName != "") {
          let Agnt = this.getagentName.filter((x) => {
            return x.agntColoaderId == this.ffExoprtDetail.agentName;
          });

          this.bookingPartyList[2].billingPartyTxt =
            "Agent_" + Agnt[0].agentName;
          this.showAdditionalMoreTaskArray[2].show =
            "Agent_" + Agnt[0].agentName;
        }
      },

      deep: true,
    },
  },
  data() {
    return {
      selectDateFormat,
      ALLMODULE: "",
      JOBSERIES: "",
      allSame: "0",
      docURL: URL_BASE_DOC,
      showLocalIgmDiv: false,
      errorContainerType: {
        noOfContainer: "",
        containerTypeId: "",
      },
      errorContainerTypeArray: {
        noOfContainer: "Enter no of Container",
        containerTypeId: "Select Container Type",
      },
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse",
        },
      ],
      firstRadio: "",

      ContainerTypeModel: {
        containerTypeId: "",
        noOfContainer: "",
        ffContainerTypeId: "",
      },
      bookingPartyList: [
        {
          billingPartyVal: "Importer",
          billingPartyTxt: "Importer",
        },
        {
          billingPartyVal: "Exporter",
          billingPartyTxt: "Exporter",
        },
        {
          billingPartyVal: "Agent",
          billingPartyTxt: "Agent",
        },

        {
          billingPartyVal: "Other",
          billingPartyTxt: "Other",
        },
      ],
      editorOption: {
        modules: {},
      },
      tempHouse: "",
      containerTypeDetailFactory: [],
      ContainerTypeSizefactory: {
        ffContainerId: "",
        containerTypeId: "",
        contfreeDays: "",

        containerNo: "",

        measurement: "",
        lineSealNo: "",
        noOfPkg: "",
        packageId: "",
        podETA: "",
        validUpto: "",
        cfsETA: "",
        icdETA: "",
        ffImportId: "",
      },
      showAdditionalMoreTaskArray: [
        {
          value: "Importer",
          show: "Importer",
        },
        {
          value: "Exporter",
          show: "Exporter",
        },

        {
          value: "Agent",
          show: "Agent",
        },

        {
          value: "Other",
          show: "Other",
        },
      ],
      jitu: ["1", "2", "3"],
      ajit: ["1", "3"],
      errorContainer: {
        containerTypeId: "",

        containerNo: "",

        measurement: "",
        lineSealNo: "",
        noOfPkg: "",
        packageId: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight",
        "Enter measurement",
        "Enter line seal no",
        "Enter no of package",
        "Enter package name",
      ],
      editorContent: "",
      isLoading: false,
      transportTypeList: [
        {
          transportTypeVal: "SeaExport",
          transportTypeText: "Sea Export",
        },
        {
          transportTypeVal: "SeaImport",
          transportTypeText: "Sea",
        },
      ],
      blTypeList: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },

        {
          blTypeVal: "MasterBL",
          blTypeTxt: "Master B/L",
        },
      ],
      blTypeListLcl: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },

        {
          blTypeVal: "Co-Loader",
          blTypeTxt: "Co-Loader",
        },
      ],

      cctypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced",
        },
        {
          ccTypeVal: "3",
          ccTypeTxt: "Not Applicable",
        },
      ],

      containerInfoList: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL",
        },
      ],

      destiHandleList: [
        {
          DHVal: "1",
          DHText: "Pridel",
        },
        {
          DHVal: "2",
          DHText: "Consignee",
        },
      ],
      deliveryModeList: [
        {
          deliveryModeVal: "CY_CY",
          deliveryModeText: "CY / CY",
        },
        {
          deliveryModeVal: "CY_RAMP",
          deliveryModeText: "CY / RAMP",
        },
        {
          deliveryModeVal: "CY_StoreDoor",
          deliveryModeText: "CY / Store Door",
        },
      ],
      deliveryTermsList: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_",
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP",
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT",
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF",
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES",
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ",
        },
      ],

      oceanFreightTermsList: [
        {
          oceanFreightTermsVal: "prepaid",
          oceanFreightTermsText: "Prepaid",
        },
        {
          oceanFreightTermsVal: "collect",
          oceanFreightTermsText: "Collect",
        },
      ],

      showAdd: false,
      getHouseBLData: [],

      shipTypeList: [
        {
          shipTypeVal: "Origin",
          shipTypeText: "Origin",
        },
        {
          shipTypeVal: "Destination",
          shipTypeText: "Destination",
        },
      ],

      agentListName: [
        {
          agentNameVal: "agentName1",
          agentNameText: "agentName1",
        },
        {
          agentNameVal: "agentName2",
          agentNameText: "agentName2",
        },
      ],

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      allAgentColoader: [],
      getagentName: [],
      ccContainers: "",
      CommodityAll: {},
      autoClientName: {},
      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth",
      ],
      notifyListArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seven",
        "Eight",
      ],
      ffExoprtDetail: {
        allModuleId: "",
        stuffingType: "",
        vesselEtaDate: "",
        multiContainer: [],
        sameConNo: false,
        noOfContainers: "",
        statusFinal: "",
        surrenderDate: "",
        originalBlRecDate: "",
        bookingParty: "",
        billingParty: "",
        portType: "",
        ffImportId: "",

        transportType: "SeaImport",
        grossWeight: "",
        containerInfo: "fcl",
        shippingId: "",
        sailDate: "",
        alertReceivedDate: "",
        importerClientId: "",
        importerName: "",
        exporterClientId: "",
        exporterName: "",
        coLoaderName: "",
        firstBLNumber: "",
        firstBLDate: "",
        firstBlType: "",
        firstBLRadio: "",
        firstOcFreghtTerms: "",
        firstBLupload: "",
        inputValue: "",
        notifyList: [
          {
            inputValue: "",
            text: "",
          },
          {
            inputValue: "",
            text: "Second",
          },
        ],
        lclmasterBLNumber: "",
        lclmasterBLDate: "",

        ccOutSourced: "",
        ccChaName: "",
        tptOutSource: "",
        tptChaName: "",
        freeDetentionDesti: "",
        etaDischargePort: "",
        etaFinalDestination: "",
        lastFreeDay: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        preCarriageBy: "",
        vesselVoyage: "",
        shipType: "",
        agentName: "",
        sourceOriginclientId: "",
        buyer: "",
        buyingHouse: "",
        otherSpecify: "",
        marksNos: "",
        containerSealNo: "",
        noOfContainer: "",
        goodsDescription: "",
        commodity: "",
        Measurement: "",
        deliveryMode: "",
        deliveryTerms: "",
        remarks: "",
        freeDaysIndiaPort: "",
        destinationHandling: "",
        igmManifestationDate: "",
        gateWayIgmNo: "",
        gatewayIgmDate: "",
        vesselArrivalDate: "",
        localIgmNo: "",
        localIgmDate: "",
      },
      arrivalDateIndex: "",
      railOutDateIndex: "",
      freeDaysIndex: "",
      getContainerList: [],
      getContainerTypeList: [],
      getContainerTypeFinal: [],

      HouseBLModel: {
        surrenderDate: "",
        originalBlRecDate: "",
        secondBLNumber: "",
        secondBLDate: "",
        secondBlType: "HouseBL",
        secondBLRadio: "",
        secondOcFreghtTerms: "",
        secondBLupload: "",
        houseBLId: "",
        inputValue: "",
        notifyList: [
          {
            inputValue: "",
            text: "",
          },
          {
            inputValue: "",
            text: "Second",
          },
        ],
      },

      HouseBLModelError: {
        secondBLNumber: "",
        secondBLDate: "",
        secondBlType: "",
        secondBLRadio: "",
      },
      multiContainer: [],
      containerNo: [],

      HouseBLModelErrorList: [
        "Enter Second B/L Number",
        "Select Second B/L Date",
        "Select Second B/L Type",
        "Select Second B/L Radio",
      ],
      getDayFromDate: "",

      deleteId: "",
      packageMaster: [],

      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getCLientData: ["gfdg"],
      showSegmentArray: [],
      openContainer: false,
      openContainerType: false,
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      showAlgo: false,
      algoConNo: "",
      errorAtleastOne: "",
      ffExportError: [
        "Select Shipping Line",
        "Select SOB Date",
        "Select Pre-Alert Date",
        "Select Importer Name",
        "Select Exporter Name",

        "Select Place of Recipt",
        "Select Load Port",
        "Select Port Of Discharge",
        "Select Final Place Delivery",
        "Enter First B/L Number",
        "Select First B/L Date",
        "Select First B/L Type",
        "Enter Second B/L Number",
        "Select Second B/L Date",
        "Select Second B/L Type",
        "Select Second B/L Type",
      ],
      ffExporterrorList: {
        shippingId: "",
        sailDate: "",
        alertReceivedDate: "",
        importerClientId: "",
        exporterClientId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        firstBLNumber: "",
        firstBLDate: "",
        firstBLRadio: "",
      },
      ffExportErrorLCL: ["Select Coloader Name"],
      ffExporterrorListLCL: {
        coLoaderName: "",
      },

      shipmentTypeName: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea Shipment",
        },
        {
          shipmentTypeVal: "Air_Shipment",
          shipmentTypeText: "Air_Shipment",
        },
      ],

      otherServicesVal: false,
      containerNoRegexError: [],

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: [],
      PortLoadList: [],
      getPortDischargeList: [],
      finalAllPlaceData: [],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      FPODTYPE: this.$sessionsStorage.get("FPODTYPE"),
      PORTYPE: this.$sessionsStorage.get("PORTYPE"),

      openShipper: false,
      validateContainerType: false,
      validateContainerTypeFinal: false,
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    DocForm,
  },
  computed: {
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    firstBlUploadView() {
      return this.ffExoprtDetail.firstBLupload != ""
        ? this.ffExoprtDetail.firstBLupload.split(",")
        : [];
    },
    secondBlUploadView() {
      if (this.HouseBLModel.secondBLupload != null) {
        return this.HouseBLModel.secondBLupload != ""
          ? this.HouseBLModel.secondBLupload.split(",")
          : [];
      } else {
        return this.HouseBLModel.secondBLupload == 0;
      }
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },

    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },

    agentNameList() {
      return this.getagentName;
    },
    getColoaderNameList() {
      return this.getColoaderName;
    },
  },
  methods: {
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    onFileChange(ID) {
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        if (ID == "FIRST") {
          formData.append(
            "moduleId",
            this.$sessionsStorage.get("editffSeaImportId")
            // +
            //   "-" +
            //   this.sbDetailArrayList.length +
            //   "-" +
            //   this.SBDetail.shippingSBId
          );
        } else {
          "moduleId",
            this.$sessionsStorage.get("editffSeaImportId") +
              "-" +
              this.getHouseBLData.length +
              "-" +
              this.HouseBLModel.houseBLId;
        }

        if (ID == "FIRST") {
          formData.append("staticFileName", "Sea_Import_FirstBL");
        } else if (ID == "SECOND") {
          formData.append("staticFileName", "Sea_Import_SecondBL");
        } else {
          console.log("error");
        }

        formData.append("upload_dir_folderName", "FF_Sea_Import_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          if (ID == "FIRST") {
            this.ffExoprtDetail.firstBLupload = result.data;
          } else if (ID == "SECOND") {
            this.HouseBLModel.secondBLupload = result.data;
          } else {
            console.log("error");
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    addSameDate(index) {
      this.arrivalDateIndex = this.multiContainer[index].arrivalDate;

      this.railOutDateIndex = this.multiContainer[index].railOutDate;
      this.freeDaysIndex = this.multiContainer[index].freeDays;
    },

    // addSameDateRadio() {
    //   if (this.firstRadio == "1") {
    //     this.multiContainer.map(x => {
    //       x.arrivalDate = this.arrivalDateIndex;
    //       x.railOutDate = this.railOutDateIndex;
    //       x.freeDays = this.freeDaysIndex;
    //     });
    //   }
    // },

    addSameDateRadio() {
      if (this.allSame == "1") {
        this.multiContainer.map((x) => {
          x.arrivalDate = "";
          x.railOutDate = "";
          x.freeDays = "";
        });
      } else {
        console.log("56565");
        this.multiContainer.map((x) => {
          x.arrivalDate = this.arrivalDateIndex;
          x.railOutDate = this.railOutDateIndex;
          x.freeDays = this.freeDaysIndex;
        });
      }
    },
    // getNoofCon() {
    //   if (
    //     this.ffExoprtDetail.noOfContainers != ""
    //     //&& this.ffExoprtDetail.ffImportId == ""
    //   ) {
    //     let array = [];
    //     for (let i = 0; i < this.ffExoprtDetail.noOfContainers; i++) {
    //       let obj = {
    //         ContainerNo: "",
    //         ContainerType: "",
    //         railOutDate: "",
    //         arrivalDate: "",
    //         freeDays: ""
    //       };

    //       // let obj1 = {
    //       //   ContainerNo1: "",
    //       //   ContainerType1: "",
    //       //   railOutDate1: "",
    //       //   arrivalDate1: "",
    //       //   freeDays1: ""
    //       // };

    //       array.push(obj);
    //       //  this.errorMultiContainer.push(obj1);
    //     }
    //     return (this.multiContainer = array);
    //   } else if (
    //     this.ffExoprtDetail.noOfContainers == "" ||
    //     this.ffExoprtDetail.noOfContainers == 0 ||
    //     this.ffExoprtDetail.noOfContainers == "0"
    //   ) {
    //     this.multiContainer = [];
    //   }
    // },
    addStatus() {
      let data = {
        jobType: "1",
        typeOf: "5",
        allMessageId: this.$sessionsStorage.get("editffSeaImportId"),
        statusMain: this.ffExoprtDetail.statusFinal,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus",
      });
    },
    DeleteList(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_sea_import_multicontainer_type",
          tableId: "ffContainerTypeId",
          isActive: "isActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            this.getData();
            this.getContainerList = [];
          })
          .catch((error) => {});
      }
    },
    // getFreeDate() {
    //   if (this.$sessionsStorage.get("FPODTYPE") == "ICD") {
    //     let newdate = new Date(this.ffExoprtDetail.etaFinalDestination);

    //     newdate.setDate(
    //       newdate.getDate() +
    //         parseInt(this.ffExoprtDetail.freeDetentionDesti) -
    //         parseInt(1)
    //     );

    //     this.ffExoprtDetail.lastFreeDay = newdate;
    //   } else {
    //     let newdatePort = new Date(this.ffExoprtDetail.etaDischargePort);

    //     newdatePort.setDate(
    //       newdatePort.getDate() +
    //         parseInt(this.ffExoprtDetail.freeDetentionDesti) -
    //         parseInt(1)
    //     );

    //     this.ffExoprtDetail.lastFreeDay = newdatePort;
    //   }
    // },
    containerNoRegexfun(index) {
      let abc = this.multiContainer[index].ContainerNo.toUpperCase();

      this.multiContainer[index].ContainerNo = abc;
      console.log(this.multiContainer[index].ContainerNo);
      this.showAlgo = true;
      this.getConAlgoList(index);
      this.algoConNo = this.validContainerNo;
      console.log(this.validContainerNo);
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      if (containerformat.test(this.multiContainer[index].ContainerNo)) {
        this.containerNoRegexError[index] = "";
        if (this.multiContainer[index].ContainerNo != this.algoConNo) {
          this.containerNoRegexError[index] =
            "Note:System Generated Container No. is : " + this.algoConNo;
        } else {
          this.containerNoRegexError[index] = "";
        }
      } else {
        this.containerNoRegexError[index] = "Enter Valid Format";
      }
      this.$forceUpdate();
    },
    getConAlgoList(index) {
      //let self = this;

      if (this.multiContainer[index].ContainerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.multiContainer[index].ContainerNo
        );
      }
    },
    showMoreShipper() {
      this.HouseBLModel.secondBlType = this.tempHouse;
      this.HouseBLModel.notifyList = [];
      let obj = {
        inputValue: "",
        text: "",
      };
      this.HouseBLModel.notifyList.push(obj);
      if (this.openShipper == false) {
        this.openShipper = true;
      } else {
        this.openShipper = false;
      }
    },
    showMoreContainer() {
      if (this.openContainer == false) {
        this.openContainer = true;
      } else {
        this.openContainer = false;
      }
    },
    showMoreContainerType() {
      if (this.openContainerType == false) {
        this.openContainerType = true;
      } else {
        this.openContainerType = false;
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    onFileChangeFirstBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId"),
        },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`,
          formData,
          config
        )
        .then((result) => {
          this.ffExoprtDetail.firstBLupload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    onFileChangeSecBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId"),
        },
      };

      axios
        .post(
          `${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`,
          formData,
          config
        )
        .then((result) => {
          this.HouseBLModel.secondBLupload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    onCloseAddSeaImp() {
      this.$router.push({
        path: "/seaImport/ffSeaImportExecution",
      });
    },

    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.HouseBLModel.notifyList.length],
      };
      this.HouseBLModel.notifyList.push(obj);
    },
    removeNotify(index) {
      this.HouseBLModel.notifyList.splice(index, 1);
    },
    addNotifyMaster() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.ffExoprtDetail.notifyList.length],
      };
      this.ffExoprtDetail.notifyList.push(obj);
    },
    removeNotifyMaster(index) {
      this.ffExoprtDetail.notifyList.splice(index, 1);
    },

    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    editHouseBL(item) {
      let arrayEdit = [];
      arrayEdit.push(item);

      this.HouseBLModel.secondBLNumber = arrayEdit[0].secondBLNumber;
      this.HouseBLModel.houseBLId = arrayEdit[0].houseBLId;
      this.HouseBLModel.secondBLDate = arrayEdit[0].secondBLDate;
      this.HouseBLModel.secondBlType = arrayEdit[0].secondBlType;
      this.tempHouse = this.HouseBLModel.secondBlType;

      this.HouseBLModel.secondBLRadio = arrayEdit[0].secondBLRadio;

      this.HouseBLModel.secondOcFreghtTerms = arrayEdit[0].secondOcFreghtTerms;

      this.HouseBLModel.secondBLupload = arrayEdit[0].secondBLupload;
      this.HouseBLModel.surrenderDate = arrayEdit[0].surrenderDate;
      this.HouseBLModel.originalBlRecDate = arrayEdit[0].originalBlRecDate;

      if (arrayEdit[0].notifyList != "" && this.HouseBLModel.houseBLId != "") {
        this.HouseBLModel.notifyList = [];
        arrayEdit[0].notifyList.split("$$$").map((y, index) => {
          let obj = {
            inputValue: y,
            text: this.notifyListArray[index],
          };

          this.HouseBLModel.notifyList.push(obj);
        });
      } else {
        this.HouseBLModel.notifyList = [];
        let obj = {
          inputValue: "",
          text: "",
        };
        this.HouseBLModel.notifyList.push(obj);
      }
    },
    editContainer(item) {
      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = item[x];
      });
    },
    validateFFExport(id) {
      let validate_new = true;

      if (id == "3") {
        Object.keys(this.HouseBLModelError).map((x, index) => {
          if (this.HouseBLModel[x] == "") {
            this.HouseBLModelError[x] = this.HouseBLModelErrorList[index];
            validate_new = false;
          } else {
            this.HouseBLModelError[x] = "";
          }
        });
      }

      if (id == "5") {
        if (
          this.getContainerTypeList.length > 0 &&
          this.ContainerTypeModel.ffContainerTypeId == ""
        ) {
          let array = this.getContainerTypeList.filter((x) => {
            return x.containerTypeId == this.ContainerTypeModel.containerTypeId;
          });
          if (array.length > 0) {
            this.alert.content = array[0].containerType + " Already Exist";
            this.ContainerTypeModel.containerTypeId = "";

            this.$refs["addPop"].open();
            validate_new = false;
          }
        }
        Object.keys(this.errorContainerType).map((x, index) => {
          if (this.ContainerTypeModel[x] == "") {
            this.errorContainerType[x] = this.errorContainerTypeArray[x];
            validate_new = false;
          } else {
            this.errorContainerType[x] = "";
          }
        });
      }

      if (id == "2") {
        Object.keys(this.errorContainer).map((x, index) => {
          if (this.ContainerTypeSizefactory[x] == "") {
            this.errorContainer[x] = this.arrayContainerError[index];
            validate_new = false;
          } else {
            this.errorContainer[x] = "";
          }
        });
      }

      if (this.ffExoprtDetail.containerInfo == "fcl") {
        Object.keys(this.ffExporterrorList).map((x, index) => {
          if (this.ffExoprtDetail[x] == "") {
            this.ffExporterrorList[x] = this.ffExportError[index];
            validate_new = false;
          }
        });
      } else {
        Object.keys(this.ffExporterrorList).map((x, index) => {
          if (this.ffExoprtDetail[x] == "") {
            this.ffExporterrorList[x] = this.ffExportError[index];
            validate_new = false;
          }
        });

        Object.keys(this.ffExporterrorListLCL).map((x, index) => {
          if (this.ffExoprtDetail[x] == "") {
            this.ffExporterrorListLCL[x] = this.ffExportErrorLCL[index];
            validate_new = false;
          }
        });
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addFFSeaImport(id) {
      this.ffExoprtDetail["multiContainer"] = this.multiContainer;
      // this.validateFFExport(id);
      if (this.multiContainer.length > 0) {
        let sameConNo = [];
        this.multiContainer.map((x) => {
          // let sameCon = this.multiContainer.filter(y => y.includes(x));
          let sameCon = this.multiContainer.filter((y) => {
            if (
              y.ContainerNo != "" &&
              y.ContainerNo != null &&
              y.ContainerNo != undefined
            ) {
              return y.ContainerNo == x.ContainerNo;
            }
          });
          if (sameCon.length > 1) {
            sameConNo.push(sameConNo);
          }
        });

        if (sameConNo.length > 0) {
          this.alert.content =
            "Duplicate Container No..! Unable to update Data";
          this.$refs["message"].open();
          return false;
        }
      }

      let new_data = {
        ffExoprtDetail: this.ffExoprtDetail,
        HouseBLModel: this.HouseBLModel,
        ContainerDetail: this.ContainerTypeSizefactory,
        ContainerDetailType: this.ContainerTypeModel,
        checkBL: id,
      };

      if (this.validate != false) {
        if (id == "1") {
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
        } else {
          $("#addButtonLoader3").css("display", "none");
          $("#loader3").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addNormalSeaImport.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              if (this.$sessionsStorage.get("editffSeaImportId") != "") {
                this.$sessionsStorage.set(
                  "editffSeaImportId",
                  this.ffExoprtDetail.ffImportId
                );
              } else {
                this.$sessionsStorage.set("editffSeaImportId", data.ffImportId);
              }
              if (id == "1") {
                $("#loader").css("display", "none");
                $("#addButtonLoader").css("display", "block");
              } else {
                $("#loader3").css("display", "none");
                $("#addButtonLoader3").css("display", "block");
              }

              if (this.ffExoprtDetail.ffImportId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }

              if (id == 1) {
                this.$refs["alertAddSeaImp"].open();
              } else if (id == "0") {
                this.$refs["message"].open();
              } else if (id == 5) {
                Object.keys(this.ContainerTypeModel).map((x) => {
                  this.ContainerTypeModel[x] = "";
                });
                this.getData();
              } else if (id == 2) {
                Object.keys(this.ContainerTypeSizefactory).map((x) => {
                  this.ContainerTypeSizefactory[x] = "";
                });
                this.openContainer = false;
                this.getData();
              } else {
                Object.keys(this.HouseBLModel).map((x) => {
                  this.HouseBLModel[x] = "";
                });
                this.openShipper = false;
                this.getData();
              }
            }
          })
          .catch((error) => {});
      }
    },

    getData() {
      this.doLoading();
      let array = [];
      this.multiContainer = [];

      let vehicle_drive = {
        itemCode: "itemCode",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
      };
      1;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/getDataNormalSeaImport1.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            let containerNo = [];
            let containerType = [];
            let railOutDate = [];
            let arrivalDate = [];
            let freeDays = [];
            if (data.ffSeaImportData.length > 0) {
              this.ALLMODULE = data.ffSeaImportData[0].allModuleId;
              this.JOBSERIES = data.ffSeaImportData[0].ffImportSeries;
              if (
                data.ffSeaImportData[0].finalPlaceLocationId !=
                data.ffSeaImportData[0].PODLocationId
              ) {
                this.showLocalIgmDiv = true;
              }
              this.ffExoprtDetail.notifyList = [];

              Object.keys(data.ffSeaImportData[0]).map((x) => {
                if (x == "notifyList") {
                  console.log(data, "oooo");
                  data.ffSeaImportData[0][x].split("$$$").map((y, index) => {
                    let obj = {
                      inputValue: y,
                      text: this.notifyListArray[index],
                    };

                    this.ffExoprtDetail.notifyList.push(obj);
                  });
                } else if (x == "ContainerNo") {
                  if (data.ffSeaImportData[0][x] != null) {
                    containerNo = data.ffSeaImportData[0][x].split(",") || [];
                  } else {
                    containerNo = [];
                  }
                  console.log(data);
                } else if (x == "ContainerType") {
                  if (data.ffSeaImportData[0][x] != null) {
                    containerType = data.ffSeaImportData[0][x].split(",") || [];
                  } else {
                    containerType = [];
                  }
                  console.log(data);
                } else if (x == "railOutDate") {
                  if (data.ffSeaImportData[0][x] != null) {
                    railOutDate = data.ffSeaImportData[0][x].split(",") || [];
                  } else {
                    railOutDate = [];
                  }
                } else if (x == "arrivalDate") {
                  if (data.ffSeaImportData[0][x] != null) {
                    arrivalDate = data.ffSeaImportData[0][x].split(",") || [];
                  } else {
                    arrivalDate = [];
                  }
                } else if (x == "freeDays") {
                  if (data.ffSeaImportData[0][x] != null) {
                    freeDays = data.ffSeaImportData[0][x].split(",") || [];
                  } else {
                    freeDays = [];
                  }
                } else {
                  this.ffExoprtDetail[x] =
                    data.ffSeaImportData[0][x] == "0"
                      ? ""
                      : data.ffSeaImportData[0][x] || "";
                }
              });
              if (containerType.length > 0) {
                console.log("ppp");
                containerType.map((x, index) => {
                  let obj = {
                    ContainerType: x,
                    ContainerNo: containerNo[index],
                    railOutDate: railOutDate[index],
                    arrivalDate: arrivalDate[index],
                    freeDays: freeDays[index],
                  };

                  this.multiContainer.push(obj);
                });
              }
              console.log(this.multiContainer);
            }

            if (data.agentColoaderData.length > 0) {
              this.getagentName = data.agentColoaderData.filter((x) => {
                return x.categoryType == "Agent";
              });

              this.getColoaderName = data.agentColoaderData.filter((x) => {
                return x.categoryType == "CoLoader";
              });
            }
            if (data.ccContainerDetails.length > 0) {
              this.ccContainers = data.ccContainerDetails[0].ContainerNo;
              //   this.multiContainer.ContainerNo.push();
            }
            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }

            if (data.getHouseBLData.length > 0) {
              this.getHouseBLData = data.getHouseBLData;
            }

            if (data.multiContainerData.length > 0) {
              this.getContainerList = data.multiContainerData;
            }
            if (data.multiContainerTypeData.length > 0) {
              this.getContainerTypeList = data.multiContainerTypeData;
              this.getContainerTypeFinal = data.multiContainerTypeFinal;
            } else {
              this.getContainerTypeList = [];
              this.getContainerTypeFinal = [];
            }

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            }
            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            }

            if (data.packageMaster.length > 0) {
              this.packageMaster = data.packageMaster;
            }

            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    previousFFView() {
      this.$router.push({
        path: "/seaImport/viewSeaImportDetails",
      });
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "Freight Forwarding(FF)",
          flex: "20",
        },
        {
          value: "CC",
          show: "Customs Clearance(CC)",
          flex: "20",
        },
        {
          value: "TPT",
          show: "Transportation(TPT)",
          flex: "20",
        },

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.mx-calendar-content {
  width: auto;
  height: auto;
}
.mx-panel-date {
  table-layout: auto;
  border-collapse: collapse;
  border-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// ffseaImportFcl.vue?955ecc78